"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    staticClass: "add_dialog",
    attrs: {
      width: "600px",
      title: _vm.dialogTitle,
      visible: _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      rules: _vm.rules,
      model: _vm.formData,
      "label-width": "140px"
    }
  }, [_vm.sMerchantId == 0 ? [_c("el-form-item", {
    attrs: {
      label: "所属商户",
      prop: "merchant_id"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择商户"
    },
    model: {
      value: _vm.formData.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "merchant_id", $$v);
      },
      expression: "formData.merchant_id"
    }
  }, _vm._l(_vm.merchantList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.username,
        value: item.id
      }
    });
  }), 1)], 1)] : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "商品主图",
      prop: "image"
    }
  }, [_c("crop-upload", {
    attrs: {
      "show-type": "photo",
      "init-val": _vm.formData.image,
      "file-size": "100K",
      "wrapper-width": "95px",
      "wrapper-height": "95px"
    },
    on: {
      setVal: function setVal(val) {
        return _vm.setUrl("image", val);
      }
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "商品标题",
      prop: "title"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入商品标题"
    },
    model: {
      value: _vm.formData.title,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "title", $$v);
      },
      expression: "formData.title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "需要积分",
      prop: "score"
    }
  }, [_c("el-input-number", {
    attrs: {
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.score,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "score", $$v);
      },
      expression: "formData.score"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "兑换说明"
    }
  }, [_c("div", {
    staticClass: "editor_wrap"
  }, [_c("text-editor", {
    model: {
      value: _vm.formData.content,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "content", $$v);
      },
      expression: "formData.content"
    }
  })], 1)]), _c("el-form-item", {
    attrs: {
      label: "状态",
      prop: "status"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formData.status,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "status", $$v);
      },
      expression: "formData.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "开启",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "关闭",
      value: 0
    }
  })], 1)], 1)], 2), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;